import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.map.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import getFullUserName from 'utils/getFullUserName';
import config from 'utils/config';
import { ONE_MB } from 'utils/file';
import { setAlert } from 'actions/alerts';
import { useFetchUserProfile, useRemoveAvatar, useUploadAvatar, useUpdateUserProfile } from 'actions/userProfile';
import Box from 'components/Box';
import Button from 'components/Button';
import Avatar from 'components/Avatar';
import FileInputLink from 'components/FileInputLink';
import PageBackLink from 'components/PageBackLink';
import Panel from 'components/Panel';
import Spinner from 'components/Spinner';
import Stack from 'components/Stack';
import TooltipButton from 'components/TooltipButton';
import ShadedCard from 'components/ShadedCard';
import Heading from 'components/Heading';
import Flex from 'components/Flex';
import TextLink from 'components/TextLink';
import FormField from 'components/FormField';
import FormStack from 'components/FormStack';
import TextInput from 'components/TextInput';
import { PROFILE_ROUTES } from 'utils/routes';

// config or config.enableUserEditName can be undefined if not toggled before,
// but we require the default to be TRUE
var enableUserEditName = (config === null || config === void 0 ? void 0 : config.enableUserEditName) !== false;
export function AvatarEditor() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var fileInputRef = useRef(null);
  var _useFetchUserProfile = useFetchUserProfile(),
    userProfile = _useFetchUserProfile.data;
  var _useRemoveAvatar = useRemoveAvatar(),
    removeAvatar = _useRemoveAvatar.removeAvatar;
  var _useUploadAvatar = useUploadAvatar(),
    uploadAvatar = _useUploadAvatar.uploadAvatar,
    isUploadingAvatar = _useUploadAvatar.isLoading;
  function uploadPhoto() {
    return _uploadPhoto.apply(this, arguments);
  }
  function _uploadPhoto() {
    _uploadPhoto = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var file;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (fileInputRef.current) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            if (!fileInputRef.current.files) {
              _context.next = 14;
              break;
            }
            file = fileInputRef.current.files[0];
            if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg') {
              _context.next = 8;
              break;
            }
            setAlert({
              key: 'upload-avatar',
              title: t('profile_file_type_warning')
            });
            fileInputRef.current.value = '';
            return _context.abrupt("return");
          case 8:
            if (!(file.size > 10 * ONE_MB)) {
              _context.next = 12;
              break;
            }
            setAlert({
              key: 'upload-avatar',
              title: t('error_file_too_large', {
                maxFileSizeInMb: 10
              })
            });
            fileInputRef.current.value = '';
            return _context.abrupt("return");
          case 12:
            _context.next = 14;
            return uploadAvatar(file);
          case 14:
            // Reset input
            fileInputRef.current.value = '';
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _uploadPhoto.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, isUploadingAvatar ? /*#__PURE__*/React.createElement(Box, {
    mt: 12,
    mb: 13
  }, /*#__PURE__*/React.createElement(Spinner, {
    dimmed: true
  })) : /*#__PURE__*/React.createElement(Box, {
    position: "relative",
    display: "inline-block"
  }, /*#__PURE__*/React.createElement(Avatar, {
    shady: true,
    size: "big",
    pictureUrl: userProfile === null || userProfile === void 0 ? void 0 : userProfile.pictureUrl
  }), Boolean(userProfile === null || userProfile === void 0 ? void 0 : userProfile.pictureUrl) && /*#__PURE__*/React.createElement(TooltipButton, {
    round: true,
    onClick: function onClick() {
      return removeAvatar();
    },
    id: "remove-user-photo",
    title: t('profile_remove_avatar'),
    icon: "x",
    size: "small",
    variant: "important",
    position: "absolute",
    top: "-xxs",
    right: "-xxs"
  })), /*#__PURE__*/React.createElement(FileInputLink, {
    id: "photoupload",
    ref: fileInputRef,
    accept: ".png,.jpg,.jpeg",
    onChange: uploadPhoto
  }, t('profile_upload_avatar')));
}
var getUserCustomFieldsValues = function getUserCustomFieldsValues(userCustomFields) {
  return userCustomFields.reduce(function (values, _ref) {
    var value = _ref.value,
      customfield_id = _ref.id,
      label = _ref.label,
      is_required = _ref.is_required;
    values[label] = {
      value: value,
      customfield_id: customfield_id,
      is_required: is_required
    };
    return values;
  }, {});
};
function EditUserSettings(_ref2) {
  var _ref2$initialFirstNam = _ref2.initialFirstName,
    initialFirstName = _ref2$initialFirstNam === void 0 ? '' : _ref2$initialFirstNam,
    _ref2$initialLastName = _ref2.initialLastName,
    initialLastName = _ref2$initialLastName === void 0 ? '' : _ref2$initialLastName,
    _ref2$email = _ref2.email,
    email = _ref2$email === void 0 ? '' : _ref2$email,
    _ref2$userCustomField = _ref2.userCustomFields,
    userCustomFields = _ref2$userCustomField === void 0 ? [] : _ref2$userCustomField;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isReadOnly = _useState2[0],
    setIsReadOnly = _useState2[1];
  var _useState3 = useState(initialFirstName),
    _useState4 = _slicedToArray(_useState3, 2),
    firstName = _useState4[0],
    setFirstName = _useState4[1];
  var _useState5 = useState(initialLastName),
    _useState6 = _slicedToArray(_useState5, 2),
    lastName = _useState6[0],
    setLastName = _useState6[1];
  var _useUpdateUserProfile = useUpdateUserProfile(),
    updateUserProfile = _useUpdateUserProfile.updateUserProfile;
  var _useState7 = useState(getUserCustomFieldsValues(userCustomFields)),
    _useState8 = _slicedToArray(_useState7, 2),
    customFieldValues = _useState8[0],
    setCustomFieldValues = _useState8[1];
  useEffect(function () {
    var values = getUserCustomFieldsValues(userCustomFields);
    setCustomFieldValues(values);
  }, [userCustomFields]);
  useEffect(function () {
    var hasBoth = Boolean(initialFirstName && initialLastName);
    if (!hasBoth && enableUserEditName) {
      setIsReadOnly(false);
    } else if (hasBoth) {
      setIsReadOnly(true);
    }
  }, [initialFirstName, initialLastName]);
  var displayName = getFullUserName({
    first_name: firstName,
    last_name: lastName
  }) || email;
  var hasCustomFieldChanges = Object.keys(customFieldValues).some(function (label) {
    var _userCustomFields$fin;
    var inputValue = customFieldValues[label].value || '';
    var userProfileValue = ((_userCustomFields$fin = userCustomFields.find(function (userCustomField) {
      return userCustomField.label === label;
    })) === null || _userCustomFields$fin === void 0 ? void 0 : _userCustomFields$fin.value) || '';
    return userProfileValue.trim() !== inputValue.trim();
  });
  var hasNameChanges = firstName !== initialFirstName || lastName !== initialLastName;
  var hasUnsavedChanges = hasNameChanges || hasCustomFieldChanges;
  function submit(e) {
    e.preventDefault();
    updateUserProfile({
      first_name: firstName || '',
      last_name: lastName || '',
      customFields: customFieldValues
    });
    setIsReadOnly(true);
  }
  function getCustomFieldChangeHandler(label) {
    return function (e) {
      e.persist();
      setCustomFieldValues(function (prevValues) {
        return _objectSpread(_objectSpread({}, prevValues), {}, _defineProperty({}, label, _objectSpread(_objectSpread({}, prevValues[label]), {}, {
          value: e.target.value
        })));
      });
    };
  }
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: submit
  }, /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(PageBackLink, {
    fallback: PROFILE_ROUTES.root
  }, t('actions_back')), /*#__PURE__*/React.createElement(ShadedCard, null, /*#__PURE__*/React.createElement(Flex, {
    breakpoints: "xxs",
    flexDirection: ['column', 'row']
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    p: "m",
    borderBottom: ['thin', 'none'],
    borderRight: ['none', 'thin'],
    textAlign: ['center', 'left'],
    width: "100%",
    breakpoints: "xxs"
  }, isReadOnly && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    as: "h1"
  }, displayName), Boolean(enableUserEditName) && /*#__PURE__*/React.createElement(TextLink, {
    as: "button",
    onClick: function onClick() {
      return setIsReadOnly(false);
    }
  }, t('actions_edit'))), !isReadOnly && /*#__PURE__*/React.createElement(FormStack, {
    spacing: "xs"
  }, /*#__PURE__*/React.createElement(FormField, {
    label: t('profile_first_name')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: firstName,
    onChange: function onChange(e) {
      return setFirstName(e.target.value);
    },
    disabled: !enableUserEditName
  })), /*#__PURE__*/React.createElement(FormField, {
    label: t('profile_last_name')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: lastName,
    onChange: function onChange(e) {
      return setLastName(e.target.value);
    },
    disabled: !enableUserEditName
  })))), /*#__PURE__*/React.createElement(Box, {
    textAlign: "center",
    minWidth: "160",
    maxWidth: "40%",
    p: ['s', 'm'],
    breakpoints: "xxs"
  }, /*#__PURE__*/React.createElement(AvatarEditor, null))))), !!userCustomFields.length && /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(ShadedCard, {
    p: "s"
  }, /*#__PURE__*/React.createElement(FormStack, null, userCustomFields.map(function (_ref3) {
    var _customFieldValues$la;
    var label = _ref3.label,
      id = _ref3.id,
      is_required = _ref3.is_required,
      hint = _ref3.hint;
    return /*#__PURE__*/React.createElement(FormField, {
      key: id,
      required: !!is_required,
      label: is_required ? "".concat(label, " *") : label,
      description: hint
    }, /*#__PURE__*/React.createElement(TextInput, {
      value: ((_customFieldValues$la = customFieldValues[label]) === null || _customFieldValues$la === void 0 ? void 0 : _customFieldValues$la.value) || '',
      onChange: getCustomFieldChangeHandler(label)
    }));
  })))), /*#__PURE__*/React.createElement(Panel, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    icon: "ok",
    variant: "primary",
    isDisabled: !hasUnsavedChanges
  }, t('actions_save'))));
}
export default EditUserSettings;